/**
 * Wettbewerberpreise — EINE Quelle für Tabelle, FAQ, Schema und Fußnote.
 * Listenpreise netto, monatlich kündbar (ohne Neukunden-Aktionen). Recherche: 21.09.2026.
 */
export const COMPETITOR_PRICES = {
  lexoffice: {
    name: 'Lexware Office (lexoffice)',
    plan: 'L',
    monthly: 21.90,
    price: '21,90 €',
    plans: [
      { plan: 'S', price: '7,90 €', scope: 'Belege erfassen & archivieren' },
      { plan: 'M', price: '12,90 €', scope: 'Angebote, Rechnungen, Mahnungen' },
      { plan: 'L', price: '21,90 €', scope: 'Buchhaltung inkl. EÜR & UStVA' },
      { plan: 'XL', price: '32,90 €', scope: 'EU-Rechnungen, Abschlagsrechnungen, API' },
    ],
    source: 'https://www.lexware.de/preise/',
    asOf: 'September 2026',
  },
  sevdesk: {
    name: 'sevDesk',
    plan: 'Buchhaltung',
    monthly: 25.90,
    price: '25,90 €',
    priceLongTerm: '19,90 €',
    plans: [
      { plan: 'Rechnung', price: '12,90 €', scope: 'Rechnungen, Angebote, DATEV' },
      { plan: 'Buchhaltung', price: '25,90 €', scope: 'EÜR, UStVA, Banking' },
      { plan: 'Buchhaltung Pro', price: '34,90 €', scope: 'Kostenstellen, API, BWA' },
    ],
    addons: [{ name: 'Zeiterfassung', price: '4,90 €' }],
    source: 'https://sevdesk.de/preise/',
    asOf: 'September 2026',
  },
};

export const IVOLIQ_PRICES = { pro: '19 €', proYearly: '15,83 €', free: '0 €' };

export function yearlySavings(competitorMonthly, ivoliqMonthly = 19) {
  const diff = (competitorMonthly - ivoliqMonthly) * 12;
  return `${diff.toFixed(2).replace('.', ',')} €`;
}
